import { render, staticRenderFns } from "./TrSelectGameWithTextV2.vue?vue&type=template&id=08b4f596&scoped=true&"
import script from "./TrSelectGameWithTextV2.vue?vue&type=script&lang=js&"
export * from "./TrSelectGameWithTextV2.vue?vue&type=script&lang=js&"
import style0 from "./TrSelectGameWithTextV2.vue?vue&type=style&index=0&id=08b4f596&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b4f596",
  null
  
)

export default component.exports